var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeasureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3009",
    "data-name": "Grupo 3009",
    transform: "translate(-30 -266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2440",
    "data-name": "Grupo 2440",
    transform: "translate(-1 -18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2442",
    "data-name": "Grupo 2442",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "medir",
    d: "M5.411,0a5.411,5.411,0,0,1,5.411,5.411h.773V7.729h-.773v3.092H5.411A5.411,5.411,0,1,1,5.411,0Zm0,2.319A3.092,3.092,0,1,0,7.6,3.224a3.092,3.092,0,0,0-2.186-.906Zm6.184,6.957h3.865v3.092H13.913V10.821H11.594Z",
    transform: "translate(38.577 293.462)",
    fill: "#fa8b94"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1288",
    "data-name": "Ret\\xE2ngulo 1288",
    width: 34,
    height: 34,
    rx: 10,
    transform: "translate(29 283)",
    fill: "#fa8b94",
    opacity: 0.1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasureIcon);
export default __webpack_public_path__ + "static/media/measureIcon.d2ec51aa0bd7e303a0a921ea79cee28e.svg";
export { ForwardRef as ReactComponent };